import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import HomeService from "../../../Services/HomeService";
import HttpClientXml from "../../../utils/HttpClientXml";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { calculateDaysAgo, formatToIndianUnits } from "../../../utils/Helper";
import "./Style.css";
import { useDispatch, useSelector } from "react-redux";
const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "#868e96",
  margin: "15px",
  fontWeight: "bold",
};

function ClientListing() {
  const userRole = localStorage.getItem("role");
  const userCity = localStorage.getItem("city");
  const loggedUserID = localStorage.getItem("uid");

  const [allData, setAllData] = useState([]);
  const [editData, setEditData] = useState(null);

  const [cities, setCities] = useState([]);
  const [localities, setLocalities] = useState([]);
  const [images, setImages] = useState([]);
  const [searchText, setSearchText] = useState("");

  const fetchAllData = async () => {
    try {
      const response = await HomeService.getClients();

      if (response.status) {
        console.log("DARAA68", response.data);

        const formattedData = response?.data
          .sort((d1, d2) => new Date(d2.createdOn) - new Date(d1.createdOn))
          .map((item, index) => ({
            id: item._id,
            sln: index + 1,
            createdOn: item?.createdOn,
            user: item?.user,
            name: item?.name,
            phone: item?.phone,
            address: item?.address,
            minBudget: item?.minBudget,
            maxBudget: item?.maxBudget,
            requirement: item?.requirement,
            typeFor: item?.typeFor,

            action: (
              <>
                <span title="Edit" onClick={() => handleEdit(item)}>
                  <i
                    className="fa-solid fa-pen-to-square"
                    style={{
                      cursor: "pointer",
                      padding: "5px",
                      marginRight: "5px",
                      fontSize: "1.5em",
                      color: "rgb(133, 218, 79)",
                      backgroundColor: "#E9F3F7",
                    }}
                  ></i>
                </span>
                <span title="Delete" onClick={() => handleDelete(item._id)}>
                  <i
                    className="fa-solid fa-trash-can text-danger"
                    style={{
                      cursor: "pointer",
                      padding: "5px",
                      marginRight: "5px",
                      fontSize: "1.5em",
                      color: "#477DA5",
                      backgroundColor: "#E9F3F7",
                    }}
                  ></i>
                </span>
              </>
            ),
          }));

        // const filteredBySearchText = formattedData?.filter(item =>
        //   item?.address?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        //   item?.area?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        //   item?.city?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        //   item?.facing?.facing?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        //   item?.propertyType?.toLowerCase()?.includes(searchText?.toLowerCase()) ||
        //   item?.price >= parseInt(searchText)
        // );

        // setAllData(filteredBySearchText || []);

        setAllData(formattedData || []);

        // if (userCity) {
        //   setAllData(formattedData.filter((item) => item?.cityId === userCity))
        // }
      } else {
        toast.error(<>{response?.message}</>);
      }
    } catch (error) {
      console.error("Error fetching allData:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await HomeService.deleteProperty(id);
      if (res?.status) {
        toast.success(res?.message);
        fetchAllData();
      } else {
        toast?.error(res?.message);
      }
      // fetchAllData();
      // toast.success("Property deleted successfully!");
    } catch (error) {
      toast.error("Failed to delete property.");
      console.error("Error deleting property:", error);
    }
  };

  const [editID, setEditID] = useState("");

  const handleEdit = (item) => {
    console.log("HTR129", item);
    setEditID(item._id);
    setEditData(item);
    //Step1 Pre Filled
    if (item.localities && item.localities.length > 0) {
      const fetchedStep1Data = {
        clientDetailId: item._id,
        localities: item.localities.map(({ locationId, status }) => ({
          locationId,
          status,
        })),
      };
      setLocalityStatus(fetchedStep1Data.localities);
      setFormStep1Data(fetchedStep1Data);
    }
    //Step2 Pre Filled
    if (item.meetingDate && item.meetingDate) {
      const fetchedStep2Data = {
        clientDetailId: item._id,
        meetingDate: item.meetingDate,
        meetingTime: item.meetingTime,
        meetingRemarks: item.meetingRemarks,
      };
      setFormStep2Data(fetchedStep2Data);
    }
    //Step3 Pre Filled
    if (
      item.dealDoneOn &&
      item.securityDeposit &&
      item.ourCommision &&
      item.yourCommission
    ) {
      const fetchedStep3Data = {
        clientDetailId: item._id,
        dealDoneOn: item.dealDoneOn,
        securityDeposit: item.securityDeposit,
        ourCommision: item.ourCommision,
        yourCommission: item.yourCommission,
      };
      setFormStep3Data(fetchedStep3Data);
    }
  };

  const columns = [
    { name: "Sl#", selector: (row) => row.sln, sortable: true },
    {
      name: "Date",
      selector: (row) => <>{moment(row?.createdOn).format("DD-MM-YYYY")}</>,
      sortable: true,
    },
    { name: "For", selector: (row) => row?.typeFor, sortable: true },
    { name: "User Name", selector: (row) => row?.user?.fullName, wrap: true },
    { name: "User Phone#", selector: (row) => row?.user?.mobileNo, wrap: true },
    { name: "Client Name", selector: (row) => row?.name, wrap: true },
    { name: "Client Phone", selector: (row) => row?.phone, wrap: true },
    { name: "Client Address", selector: (row) => row?.address, wrap: true },
    {
      name: "Minimum Budget",
      selector: (row) => (
        <>
          <i class="fa fa-indian-rupee-sign" style={{ marginRight: "3px" }}></i>
          {row.minBudget}
        </>
      ),
      wrap: true,
      sortable: true,
    },
    {
      name: "Maximum Budget",
      selector: (row) => (
        <>
          <i class="fa fa-indian-rupee-sign" style={{ marginRight: "3px" }}></i>
          {row.maxBudget}
        </>
      ),
      wrap: true,
      sortable: true,
    },
    // {
    //   name: "Budget", selector: (row) => (
    //     <>
    //       <i class="fa fa-indian-rupee-sign"
    //         style={{
    //           marginRight: "3px"
    //         }}
    //       ></i>{row.minBudget} - <i class="fa fa-indian-rupee-sign"
    //         style={{
    //           marginRight: "3px"
    //         }}
    //       ></i>{row.maxBudget}
    //     </>
    //   )
    // },
    { name: "Requirement", selector: (row) => row?.requirement, wrap: true },
    {
      name: "Action",
      selector: (row) => row.action,
      sortable: true,
      style: { textAlign: "center" },
    },
  ];

  // Fetch localities
  const fetchLocalities = async (cityId) => {
    try {
      const res = await HomeService.getLocalities();

      if (res?.data) {
        // console.log("HYT381", res.data.filter((item) => item?.city._id === cityId), cityId);
        setLocalities(res.data.filter((item) => item?.city?._id === cityId));
      }
    } catch (error) {
      console.error("Error fetching localities:", error);
    }
  };

  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    city: userCity || "",
    locality: "",
    name: "",
  });

  const [formStep1Data, setFormStep1Data] = useState({
    clientDetailId: "",
    localityStatus: [],
    // remarks: "",
    // notResponded: false
  });

  const [formStep2Data, setFormStep2Data] = useState({
    clientDetailId: "",
    meetingDate: "",
    meetingTime: "",
    meetingRemarks: "",
  });

  const [formStep3Data, setFormStep3Data] = useState({
    clientDetailId: "",
    dealDoneOn: 0,
    securityDeposit: 0,
    ourCommision: 0,
    yourCommission: 0,
  });

  useEffect(() => {
    fetchLocalities(editData?.user?.city);
  }, [editData]);

  useEffect(() => {
    fetchAllData();
  }, []);

  const [step, setStep] = useState(1);

  const nextStep = async () => {
    console.log("UUY211", step);

    if (step === 1) {
      const submitData = {
        clientDetailId: editData._id,
        localities: localityStatus,
      };

      setFormStep1Data(submitData);
      try {
        const res = await HomeService.addClientDealLocationInterest(submitData);
        console.log("YYT224", res);
        if (res?.status) {
          toast.success("Location interest recorded successfully");
          setStep((prev) => (prev < 3 ? prev + 1 : prev));
        } else {
          toast.error(
            <>
              <p>
                <strong>Error while saving record!</strong>
                <br />
                {res.message}
              </p>
            </>,
          );
        }
      } catch (error) {
        toast.error("Error occured");
        console.error("Error adding city:", error);
      }
    } else if (step === 2) {
      if (!formStep2Data.meetingDate)
        return toast.error("Meeting date should not be empty!");
      const submitData = {
        ...formStep2Data,
        clientDetailId: editData._id || formStep1Data.clientDetailId,
      };
      setFormStep2Data(submitData);
      console.log("QWS246", submitData);
      try {
        const res = await HomeService.addClientDealMeeting(submitData);
        console.log("YYT224", res);
        if (res?.status) {
          toast.success("Meeting details recorded successfully");
          setStep((prev) => (prev < 3 ? prev + 1 : prev));
        } else {
          toast.error(
            <>
              <p>
                <strong>Error while saving record!</strong>
                <br />
                {res.message}
              </p>
            </>,
          );
        }
      } catch (error) {
        toast.error("Error occured");
        console.error("Error adding city:", error);
      }
    } else if (step === 3) {
      // const submitData = Object.fromEntries(
      //   Object.entries(formStep3Data).map(([key, value]) => [
      //     key,
      //     key === "clientDetailId" ? editData._id || formStep1Data.clientDetailId || formStep2Data.clientDetailId : parseInt(value)
      //   ])
      // );
      const submitData = {
        ...formStep3Data,
        clientDetailId: editData._id || formStep1Data.clientDetailId,
      };
      setFormStep3Data(submitData);
      console.log("QWS275", submitData);
      // return
      try {
        const res = await HomeService.addClientDealAmount(submitData);
        console.log("YYT224", res);
        if (res?.status) {
          toast.success("Meeting details recorded successfully");
          cancelEdit();
        } else {
          toast.error(
            <>
              <p>
                <strong>Error while saving record!</strong>
                <br />
                {res.message}
              </p>
            </>,
          );
        }
      } catch (error) {
        toast.error("Error occured");
        console.error("Error adding city:", error);
      }
    }

    // setStep((prev) => (prev < 3 ? prev + 1 : prev))
  };
  const prevStep = () => {
    setStep((prev) => (prev > 1 ? prev - 1 : prev));
  };

  const statusValues = [
    {
      value: 0,
      title: "No response",
    },
    {
      value: 1,
      title: "Interested",
    },
    {
      value: 2,
      title: "Not interested",
    },
  ];
  /////////////////////
  const initialLocalityStatus = {
    locationId: "",
    status: 0,
  };

  const [localityStatus, setLocalityStatus] = useState([initialLocalityStatus]);
  const handleChange = (i, e) => {
    let newFormValues = [...localityStatus];
    if (e.target.name === "status") {
      newFormValues[i][e.target.name] = parseInt(e.target.value);
    } else {
      newFormValues[i][e.target.name] = e.target.value;
    }

    setLocalityStatus(newFormValues);
  };

  const addLocalityStatus = () => {
    if (localityStatus?.length < 5000) {
      setLocalityStatus([...localityStatus, initialLocalityStatus]);
    }
  };

  const removeLocalityStatus = (i) => {
    let newFormValues = [...localityStatus];
    newFormValues.splice(i, 1);
    setLocalityStatus(newFormValues);
  };

  //////////////////////////

  const cancelEdit = () => {
    setStep(1);
    setEditData(null);
    setLocalityStatus([initialLocalityStatus]);
    setFormStep1Data({});
    setFormStep2Data({});
    setFormStep3Data({});
  };
  return (
    <div className="main_wrap">
      <div className="container-fluid" id="edit-section">
        <div className="mt-5">
          <h2 className="text-center" style={headLineStyle}>
            {editData ? "Deal Details" : "Client Listing"}
          </h2>
          <hr />
          {editData ? (
            <section className="chartBox_area">
              <div className="form-container">
                {/* Step Progress Indicator */}
                <div className="row">
                  <div className="col-md-12 progress-container">
                    {[1, 2, 3].map((num) => (
                      <div key={num} className="step-wrapper">
                        <div
                          className={`step-circle ${step >= num ? "active" : ""}`}
                        >
                          {num}
                        </div>
                        {num !== 3 && (
                          <div
                            className={`step-line ${step > num ? "filled" : ""}`}
                          ></div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                {/* Form Steps */}
                <div className="form-box">
                  {step === 1 && (
                    <>
                      {/* <button className="btn next" onClick={nextStep}>Next</button> */}
                      <div className="row mt-3">
                        <div className="col-lg-12">
                          {/* <form> */}

                          <table className="table-loc">
                            <thead>
                              <tr>
                                <th>Location</th>
                                <th>Status</th>
                                <th>&nbsp;</th>
                              </tr>
                            </thead>
                            <tbody>
                              {localityStatus?.map((element, index) => (
                                <>
                                  <tr>
                                    <td>
                                      <select
                                        className="form-control"
                                        name="locationId"
                                        value={localityStatus[index].locationId}
                                        onChange={(e) => handleChange(index, e)}
                                      >
                                        <option value="">---Select---</option>
                                        {localities.map((item, key) => (
                                          <option key={key} value={item._id}>
                                            {item.name}
                                          </option>
                                        ))}
                                      </select>
                                    </td>
                                    <td className="mr-2">
                                      <select
                                        className="form-control"
                                        name="status"
                                        value={localityStatus[index].status}
                                        onChange={(e) => handleChange(index, e)}
                                      >
                                        <option value="">---Select---</option>
                                        {statusValues.map((item, key) => (
                                          <option key={key} value={item.value}>
                                            {item.title}
                                          </option>
                                        ))}
                                      </select>
                                    </td>

                                    {index ? (
                                      <>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-success ml-1"
                                            onClick={() => addLocalityStatus()}
                                          >
                                            <i class="fas fa-plus"></i>
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-danger ml-1"
                                            onClick={() =>
                                              removeLocalityStatus(index)
                                            }
                                          >
                                            <i class="fas fa-trash"></i>
                                          </button>
                                        </td>
                                      </>
                                    ) : (
                                      <>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-success ml-1"
                                            onClick={() => addLocalityStatus()}
                                          >
                                            <i class="fas fa-plus"></i>
                                          </button>
                                        </td>
                                      </>
                                    )}
                                  </tr>
                                </>
                              ))}
                            </tbody>
                          </table>

                          {/* </form> */}
                        </div>
                        {/* <div className="col-md-12 mt-3">
                          <label>
                            Remarks
                          </label>

                          <textarea
                            className="form-control"
                            name="remarks"
                            value={formStep1Data.remarks}
                            onChange={(e) => setFormStep1Data({ ...formStep1Data, remarks: e.target.value })}
                            placeholder="Enter remarks (if any)"
                          ></textarea>
                        </div> */}

                        <div className="col-md-12">
                          <div className="checkbox-container">
                            <input
                              type="checkbox"
                              name="notResponded"
                              checked={formStep1Data.notResponded}
                              onChange={(e) =>
                                setFormStep1Data({
                                  ...formStep1Data,
                                  notResponded: !formStep1Data.notResponded,
                                })
                              }
                            />
                            <label>Client not responded</label>
                          </div>
                        </div>

                        <div className="col-md-12 mt-3 button-group">
                          <button
                            className="btn back"
                            onClick={() => cancelEdit()}
                          >
                            Back
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={() => nextStep()}
                          >
                            Save & Continue
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  {step === 2 && (
                    <>
                      <div className="row mt-3">
                        <div className="col-lg-12">
                          <table className="table-loc">
                            <thead>
                              <tr>
                                <th colSpan={2}>Schedule Meeting</th>
                              </tr>
                            </thead>
                            <tbody>
                              {localityStatus?.map((element, index) => (
                                <>
                                  <tr>
                                    <td>
                                      {localities.find(
                                        (item) =>
                                          item._id ===
                                          localityStatus[index].locationId,
                                      )?.name || ""}
                                    </td>
                                    <td className="mr-2">
                                      <span
                                        className={
                                          statusValues.find(
                                            (item) =>
                                              item.value ===
                                              localityStatus[index].status,
                                          )?.title === "Interested"
                                            ? "interested"
                                            : statusValues.find(
                                                  (item) =>
                                                    item.value ===
                                                    localityStatus[index]
                                                      .status,
                                                )?.title === "Not interested"
                                              ? "not-interested"
                                              : ""
                                        }
                                      >
                                        {statusValues.find(
                                          (item) =>
                                            item.value ===
                                            localityStatus[index].status,
                                        )?.title || "Not Selected"}
                                      </span>
                                    </td>
                                  </tr>
                                </>
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <div className="col-md-12 mt-3">
                          <label style={{ fontWeight: "bold" }}>
                            Meeting Date<span className="text-danger">*</span>
                          </label>

                          <input
                            className="form-control"
                            type="date"
                            name="meetingDate"
                            value={formStep2Data?.meetingDate?.split("T")[0]}
                            onChange={(e) =>
                              setFormStep2Data({
                                ...formStep2Data,
                                meetingDate: e.target.value,
                              })
                            }
                            placeholder="Enter date"
                            required
                          ></input>
                        </div>

                        <div className="col-md-12 mt-3">
                          <label style={{ fontWeight: "bold" }}>
                            Meeting Time
                          </label>

                          <input
                            className="form-control"
                            type="time"
                            name="meetingTime"
                            value={formStep2Data?.meetingTime}
                            onChange={(e) =>
                              setFormStep2Data({
                                ...formStep2Data,
                                meetingTime: e.target.value,
                              })
                            }
                            placeholder="Enter time"
                          ></input>
                        </div>

                        <div className="col-md-12 mt-3">
                          <label>Remarks</label>

                          <textarea
                            className="form-control"
                            name="remarks"
                            value={formStep2Data.meetingRemarks}
                            onChange={(e) =>
                              setFormStep2Data({
                                ...formStep2Data,
                                meetingRemarks: e.target.value,
                              })
                            }
                            placeholder="Enter remarks (if any)"
                          ></textarea>
                        </div>

                        <div className="col-md-12 mt-3 button-group">
                          <button className="btn back" onClick={prevStep}>
                            Back
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={() => nextStep()}
                          >
                            Save & Continue
                          </button>
                        </div>
                      </div>

                      {/* <div>
                      <h2>Step 2: Enter Email</h2>
                      <input type="email" className="input-field" placeholder="Your Email" />

                      <div className="button-group">
                        <button className="btn back" onClick={prevStep}>Back</button>
                        <button className="btn next" onClick={nextStep}>Next</button>
                      </div>
                    </div> */}
                    </>
                  )}

                  {step === 3 && (
                    <>
                      <div className="row mt-3">
                        <div className="col-md-12 mt-3">
                          <label style={{ fontWeight: "bold" }}>
                            Deal done on
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="dealDoneOn"
                            value={formStep3Data?.dealDoneOn}
                            onChange={(e) =>
                              setFormStep3Data({
                                ...formStep3Data,
                                dealDoneOn: e.target.value,
                              })
                            }
                            placeholder="Enter amount"
                          ></input>
                        </div>

                        <div className="col-md-12 mt-3">
                          <label style={{ fontWeight: "bold" }}>
                            Security deposite
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="securityDeposit"
                            value={formStep3Data?.securityDeposit}
                            onChange={(e) =>
                              setFormStep3Data({
                                ...formStep3Data,
                                securityDeposit: e.target.value,
                              })
                            }
                            placeholder="Enter amount"
                          ></input>
                        </div>

                        <div className="col-md-12 mt-3">
                          <label style={{ fontWeight: "bold" }}>
                            Our commission
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="ourCommision"
                            value={formStep3Data?.ourCommision}
                            onChange={(e) =>
                              setFormStep3Data({
                                ...formStep3Data,
                                ourCommision: e.target.value,
                              })
                            }
                            placeholder="Enter amount"
                          ></input>
                        </div>

                        <div className="col-md-12 mt-3">
                          <label style={{ fontWeight: "bold" }}>
                            User commission
                          </label>
                          <input
                            className="form-control"
                            type="text"
                            name="yourCommission"
                            value={formStep3Data?.yourCommission}
                            onChange={(e) =>
                              setFormStep3Data({
                                ...formStep3Data,
                                yourCommission: e.target.value,
                              })
                            }
                            placeholder="Enter amount"
                          ></input>
                        </div>

                        <div className="col-md-12 mt-3 button-group">
                          <button className="btn back" onClick={prevStep}>
                            Back
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={() => nextStep()}
                          >
                            Complete
                          </button>
                        </div>
                      </div>

                      {/* <div>
                        <h2>Step 3: Set Password</h2>
                        <input type="password" className="input-field" placeholder="Password" />
                        <div className="button-group">
                          <button className="btn back" onClick={prevStep}>Back</button>
                          <button className="btn submit">Submit</button>
                        </div>
                      </div> */}
                    </>
                  )}
                </div>
              </div>
            </section>
          ) : (
            <>
              <section className="chartBox_area">
                <div className="row">
                  <div className="col-lg-12 mt-3">
                    <DataTable
                      columns={columns}
                      data={allData}
                      pagination
                      persistTableHead
                    />
                  </div>
                </div>
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ClientListing;
